import type { ReactNode } from 'react';
import type { RegistrationNumberAlertFormState } from '../../../services/update-form/registrationNumberAlert';

export interface UseRegistrationNumberAlertApplied {
  arrivalNotepadApplied: boolean;
  icon: ReactNode | null;
}

export type ArrivalNotepadPropsKeys = Array<ArrivalNotepadProps>;

export type ArrivalNotepadProps =
  | 'vehicleType'
  | 'height'
  | 'length'
  | 'loadingListMessage'
  | 'goods'
  | 'hazardousGoods'
  | 'vehicleRegNo';

export const getKeysToChangeForArrivalNotepad = (
  registrationNumberAlert: RegistrationNumberAlertFormState,
): ArrivalNotepadPropsKeys => {
  const keys: ArrivalNotepadPropsKeys = [];
  if (registrationNumberAlert.appliedArrivalNotepad) {
    keys.push('vehicleRegNo');
    keys.push('vehicleType');
    if (registrationNumberAlert.appliedLength) {
      keys.push('length');
    }
    if (registrationNumberAlert.appliedHeight) {
      keys.push('height');
    }
    if (registrationNumberAlert.appliedLoadingListMessage) {
      keys.push('loadingListMessage');
    }
    if (registrationNumberAlert.appliedGoods) {
      keys.push('goods');
    }
    if (registrationNumberAlert.appliedHazardousGoods) {
      keys.push('hazardousGoods');
    }
  }

  return keys;
};
